import Axios from '../../../utils/axios'

export const loadFeaturesAuditTrail = (data) => dispatch => {
  return Axios.get('/admin/features-audit-trails', dispatch, 'GET_FEATURES_AUDIT_TRAIL', data)
}
